import './DragAndDrop.scss'
import React, { useRef, useEffect, useCallback } from 'react'
import { fromEvent, forkJoin } from 'rxjs'
import { tap } from 'rxjs/operators'
import { Icon } from 'semantic-ui-react'

export default function DragAndDrop({ height, width, message, onDrop, onRemove }) {

    const dropArea = useRef()

    function preventEvent(event) {
        event.preventDefault()
        event.stopPropagation()
    }

    const handleDragIn = useCallback(() => {
        dropArea.current.classList.toggle("dragging")
    }, [])

    const handleDragOut = useCallback(() => {
        dropArea.current.classList.toggle("dragging")
    }, [])

    const handleOver = useCallback(() => {}, [])

    const handleClick = useCallback(() => {
        dropArea.current.querySelector("input[name='input-file']").click()
    }, [])

    const handleRemove = useCallback(file => {
        
        if (onRemove)
            onRemove(file)

        const emptyView = document.createElement('DIV')
        emptyView.className = "empty-view"
        emptyView.onclick = () => handleClick()
        emptyView.style.height = height ? height + "px" : '50%'
        emptyView.style.width = width ? width + "px" : '50%'
        emptyView.innerHTML = "<div>Clique aqui <br /> ou <br /> Arraste o arquivo!</div>"

        dropArea.current.removeChild(dropArea.current.lastChild)
        dropArea.current.insertAdjacentElement("beforeend", emptyView)

        const removeIcon = dropArea.current.querySelector('.remove-icon')
        removeIcon.style.display = "none"

    }, [onRemove, height, width, handleClick])

    const handleDrop = useCallback((event) => {
   
        if (/dragging/g.test(dropArea.current.classList.value))
            dropArea.current.classList.toggle("dragging")
        if ( (event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files.length > 0) || (event.currentTarget.files && event.currentTarget.files.length > 0) ) {
            const [file] = event.dataTransfer ? event.dataTransfer.files : event.currentTarget.files
            const embed = document.createElement("embed")
            embed.src = URL.createObjectURL(file)
            embed.type = file.type
            embed.border = 0
            embed.height = height
            embed.width = width

            dropArea.current.removeChild(dropArea.current.lastElementChild)
            dropArea.current.insertAdjacentElement("beforeend", embed)

            if (onDrop)
                onDrop(file)

            const removeIcon = dropArea.current.querySelector('.remove-icon')
            removeIcon.style.display = "block"
            removeIcon.onclick = () => handleRemove(file)
            
        }
    }, [onDrop, height, width, handleRemove])

    useEffect(() => {
        const subscription = forkJoin({
            dragEnter: fromEvent(dropArea.current, 'dragenter').pipe(tap(preventEvent), tap(handleDragIn)),
            dragLeave: fromEvent(dropArea.current, 'dragleave').pipe(tap(preventEvent), tap(handleDragOut)),
            dragOver: fromEvent(dropArea.current, 'dragover').pipe(tap(preventEvent), tap(handleOver)),
            drop: fromEvent(dropArea.current, 'drop').pipe(tap(preventEvent), tap(handleDrop))
        }).subscribe()

        return () => {
            subscription.unsubscribe()
        }
    }, [handleDrop, handleDragIn, handleDragOut, handleOver])

    return (
        <div className="dnd-wrapper" ref={dropArea}>
            <Icon name="times" className='remove-icon' size='large' color="red" />
            <input className='input-file' type="file" name="input-file" onChange={handleDrop}/>
            <div className='message-wrapper'>
                <div className='message'><div>{message ? message : 'Solte aqui :)'}</div></div>
            </div>
            <div className="empty-view" style={{height: height ? height : '50%', width: width ? width : '10%' }} onClick={handleClick}>
                <div>Clique aqui <br /> ou <br /> Arraste o arquivo!</div>
            </div>
        </div>
    )
}
